<script>
import axios from "axios";
import appConfig from "@/app.config";
import i18n from "@/helpers/i18n";
import apigeneric from "@/helpers/apigeneric";
import store from "@/state/store"; 
import AltMenu from "./menu.vue"
import MobilAltMenu from "./mobilmenu.vue"
//import simplebar from "simplebar-vue";

/**
 * Nav-bar Component
 */
export default {
  props: {
    WebSiteConfig: [String, Object],
  },
  mixins: [ apigeneric],
  page: {
    title: "Web Siteleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      UserTur: null,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      
      languages: [
         {
          flag: require("@/assets/images/flags/tr.jpg"),
          language: "tr",
          title: "Türkçe",
        },
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/french.jpg"),
          language: "fr",
          title: "French",
        },
        {
          flag: require("@/assets/images/flags/spain.jpg"),
          language: "es",
          title: "Spanish",
        },
        {
          flag: require("@/assets/images/flags/chaina.png"),
          language: "zh",
          title: "Chinese",
        },
        {
          flag: require("@/assets/images/flags/arabic.png"),
          language: "ar",
          title: "Arabic",
        },
          
      ],
      lan: "i18n.locale",
      text: null,
      flag: null,
      value: null,
      MenuRoleKontrol:false, 
      isAuth:null,
      MenuData:{},
      AuthKontrol:null,
      MobilMenu:false,
      x: {}
      
    };
  },
  components: {  
    AltMenu,MobilAltMenu
    },
  mounted() { 
    this.isAuth = store.getters.["auth/isAuth"] 
    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;
    this.MuneRolesControl();
  },
  created(){
    if(localStorage.getItem("lang") == null){
      localStorage.setItem("lang", "tr");
      this.lan=localStorage.getItem("lang")
    }else{
      this.lan = localStorage.getItem("lang")
    }
    localStorage.setItem("i18nextLng", this.lan);
    this.$router.push({
        params: {LangId: this.lan}
      })

      i18n.locale = localStorage.getItem("lang")
      
  },
  methods: {
    Get(){
      let Page = {
      PageNumber: "1",
      PageSize: "9999",
      PageDataSize: "1", 
    };
      this.ActionsFilterGet({
                  Service: this.$config.API_URL_2 + "mznfirma",
                  Page: this.Page,
                  Filter: "&Userid=" + this.TokenUserId,
                }).then((responsefirma) => {
                  if (responsefirma.Data.length > 0) {
                    this.UserTur= 'Firma'
                    this.FirmaData = responsefirma.Data
                  }else{
                    this.UserTur= 'Mezun'
                  }

    this.AuthKontrol = store.getters.['auth/isAuth']
  });
    this.ActionsFilterGet({ Service: "menus/gettree", 
    Page: Page,
     Filter: "&Asc=Dataorder&Websiteid="+window.$cookies.get("ecampuswebsite")}).then(
        (res) => {
          this.MenuData = res.Data; 
         if(this.UserTur == 'Mezun'){
          this.ActionsFilterGet({
        Service: "configs",
        Page: this.Page,
        Filter: "&Websiteid=" + window.$cookies.get("ecampuswebsite"),
      }).then((resp) => {
            for(var Data in this.MenuData){
              if((this.MenuData[Data].Link === '/mznmezunlar' || this.MenuData[Data].Link === '/maps') && resp.Data[0].Mezunlarbirbirinigorsun == false){
              this.MenuData[Data].Isprivate = true;
            }
          } 
        });
          } 

        }
      );
 
    },
    MuneRolesControl() {  
      let YetkiSorgu = this.UserRolles.filter((item) =>
        item.includes("SuperAdmin") || item.includes("SatAdmin")
      );
      if (YetkiSorgu.length != 0) this.MenuRoleKontrol = true; 
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country, flag) { 
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      i18n.locale = locale;
      localStorage.setItem("lang",this.lan)
      this.$router.push({
        params: {LangId: locale}
      })
      window.location.reload();
    },
    logoutUser() {
      // eslint-disable-next-line no-unused-vars
      axios.get("http://127.0.0.1:8000/api/logout").then((res) => {
        this.$router.push({
          name: "default",
        });
      });
    },
  },
};
</script>

<template>
  <header class="header">
    <div>
      <div class="container">
        <div class="menu-section">
          <div >
            <a href="/">
              <img src="/assets/images/Kurum_Logo.png" alt="Logo" style="width: 130px; height: auto; margin-top: -10px;"/>
            </a>
          </div>
          <button
            class="menu-btn"
            aria-label="main menu"
            @click="MobilMenu = !MobilMenu"
          >
            <svg width="45" height="45" viewBox="17 15.33 80.53 69.34">
              <path
                class="line line1"
                d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058"
              ></path>
              <path class="line line2" d="M 20,50 H 80"></path>
              <path
                class="line line3"
                d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942"
              ></path>
            </svg>
          </button>

          <div class="menu mobile-hidden">
            <ul class="menu-list">
              <li
                class="list-item"
                v-for="(Data, index) in MenuData"
                :key="index"
              >
                <a v-if="!Data.Auth" :href="Data.Link + '/' + lan" class="link"
                  >{{ Data.Title }}
                </a>
                <a
                  v-if="Data.Auth && AuthKontrol && UserTur == 'Mezun' && Data.Isprivate != true"
                  :href="Data.Link"
                  class="link"
                  >{{ Data.Title }}
                </a>
                <a
                  v-if="
                    Data.Auth &&
                    AuthKontrol &&
                    UserTur == 'Firma' &&
                    Data.Title !== 'Harita'
                  "
                  :href="Data.Link"
                  class="link"
                  >{{ Data.Title }}
                </a>
                <AltMenu :MenuData="Data.Children" v-if="Data.Children" />
              </li>
            </ul>
          </div>

          <div class="account-btn mobile-hidden">
            <ul class="account-item">
              <li class="login" v-if="!isAuth">
                <a href="/login" class="sign-in">Giriş Yap</a>
              </li>

              <b-dropdown
                v-if="isAuth"
                right
                variant="black"
                toggle-class="header-item"
                menu-class="dropdown-menu-end"
              >
                <template v-slot:button-content>
                  <img
                    class="rounded-circle header-profile-user"
                    :src="
                      Avatar
                        ? Avatar
                        : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAeCAMAAACR41cYAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAJ/UExURUdwTCEgIB8fHyAfHyAfHyAfHyAfHx8eHiAfHx8eHiAfHyAfHyAfHx8eHiAfH5jU5h8eHiAfHyAfHyAfHx8eHh8eHiAfHyAfIAQBAxgWFiEhISEgIAwCACAgIB0bGi40NhkVFCAfH5za8FBncENVXKTm95vZ8Jza8J7c8R0bGhMTEx0cHCAfHyEgH73//yEgIJ7c8QAAAIfF6TM7PwwJCh4cHHm45SAfHyAfH5za8CAfH5za8Jza8Jza8Jza8CAfH5za8G6VokRVWxIKCJza8JvY7pza8DtITTlFSZ3b8AMHCgAABJza8ElBPDA4PFVLRK3z/zEvLRcXGEVBPTA5PJza8AADB5vZ74XD6QIAAIrJ67T+/4HA6BAIByAfH4zK7IrI6zE4O7D5/yAfHwEAACIgIJza8BUWGAACBhoaGvXLsQ0PEZ/g957c8RATFf/oy1p4hfzRticqLIC+6Jrm///jxiMiIvDEq//Xu/bHq//fxG5eVRgXF////P/z0P/22lNHQv/gv//877H5/xcTEhUOC76cicyolCcjIf/avdivlpvY7mZaUQMHC1lNRfrNsPTJr//o0v/cwf3WuHtnXIshF4VuYvTEqfrcyM+oqOrW1PTm4v716zM7PqHf8v/t1SkpJsD//1RueGebxaPn/IXK/TVIV3OapbmXheK0mNuymv/GrdWZhu/Tx+u7pI54adymkf/658+dlMifn+S1mafq+7uhizYvLeLCufLs7/rk1mNVTf/NrtOskqeHd8aXlXFgVv/kwZU1LNW1neK9tJAuJsCMirJwa+nKv9zFx2CRtVuKronG6naszSUnKUZaZG+TmUFPU3agr3GkxIu8xSfH+3sAAABzdFJOUwD97RwqJTMat/4VL6DlCwmSOh2qV77yhGEIms8njIj9+xEk6wESA6CMcwRtUGQlwnjIs9iu9u3fsS5e3hvwhB66hguP9eJfotdT9nPf4o7mPNW62Kc/5MnTMeRzzcTG3/LkYv////////////////////54WQMpAAACTklEQVQYGXXABVMiYRgA4BdYdhkExa5TR8Xuvu7u7v5g2V06XFGxO7C72+vu7s74Qaczd87sIg/85yeUJMMCsUK+FFzIEEISvwSZxF8iSwpEczyBT4L4xMAXhniE4CIQ8QRgwCMWID458PgipEYag0ZD07TGYHCgOcuBI1GIWA3lqEcOrVbrUNdXUzSLfIHDB7EG7fXGi411tRdq6y7dedrl1KjTgGMNop3PSm+WGO35+fkNHSUlpT0U8geO4ABneUX7w9tXWxmGKXzU/7HyyX2tBLhCVT0vh/q7b7W3MW1Fb169H6p4TIXAP1IRQfiIMV/qRUXl8+4HHUwnY//w9l1lZ7kzHBP7EIRICpg3juMemLd2zGwcHOjrLbjB9PYNDI72sgYc88Bx3BsDQiSN9FQCpFDFxrKyVvO1KwXmwtGy0i4qBUDpGSkVEbDA73D5vYIGo/2y3Vhkfl28PQl4NoQABAdl79vV0lzc3LLnwP4dBPB4rbNkwbwM1byMRHAVk7qe3gIAyWpWIBCwKAgWFTS8dfdBQY5cIMsRsv6wuARLhIU+rUBhKCQgFNwIPrYkTR6uVqjD80LBvWxhIFKgsLxT4IYy9XyWJbo6ujo64tyJvbGwiM1H9OM/kalmosb0bXhct2m1F/DExpG6KZPqxy/Vd9XsrGriro5cEQVcUSSp05s+T0XU/HGM6T6Z9DqSjAcur7Vkk77KNjnzu+rrzKStSt9ErloGfOk7yRGr1Tb9ZdpmtY6QG+NWgivlofTMk2dyz+YeP5oZvy0GFvwFlSbPVswTomsAAAAASUVORK5CYII='
                    "
                    :alt="UserNameSurName"
                  />
                  <span class="d-none d-xl-inline-block ms-1">{{
                    UserNameSurName
                  }}</span>
                  <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
                </template>

                <b-dropdown-item>
                  <router-link tag="span" to="/profiledit">
                    <i
                      class="mdi mdi-account font-size-16 align-middle me-1"
                    ></i>
                    {{ $t("navbar.kullanici.profil") }} {{ GetUserTur }}
                  </router-link>
                </b-dropdown-item>
                <b-dropdown-item>
                  <router-link tag="span" to="/mzneposta">
                    <i
                      class="mdi mdi-account-multiple font-size-16 align-middle me-1"
                    ></i>
                    {{ $t("navbar.kullanici.mzneposta") }} 
                  </router-link>
                </b-dropdown-item>
                <b-dropdown-item>
                  <router-link tag="span" to="/logout">
                    <i
                      class="
                        bx bx-power-off
                        font-size-16
                        align-middle
                        me-1
                        text-danger
                      "
                    ></i>
                    {{ $t("navbar.kullanici.cikisyap") }}
                  </router-link>
                </b-dropdown-item>
              </b-dropdown>
              <b-dropdown variant="white" right toggle-class="header-item">
                <template v-slot:button-content>
                  <img class :src="flag" alt="Header Language" height="13" />
                  {{ text }}
                </template>
                <b-dropdown-item
                  class="notify-item"
                  v-for="(entry, i) in languages"
                  :key="`Lang${i}`"
                  :value="entry"
                  @click="setLanguage(entry.language, entry.title, entry.flag)"
                  :class="{ active: lan === entry.language }"
                >
                  <img
                    :src="`${entry.flag}`"
                    alt="user-image"
                    class="me-1"
                    height="12"
                  />
                  <span class="align-middle" style="font-size: 14px">{{
                    entry.title
                  }}</span>
                </b-dropdown-item>
              </b-dropdown>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="mobile-menu" :class="MobilMenu ? 'd-block' : 'd-none'">
      <ul class="menu-list">
        <li class="account-list-item" v-if="!isAuth">
          <a href="/login" class="sign-in-mobile account-btn">Giriş Yap</a>
          <b-dropdown
            v-if="isAuth"
            right
            variant="black"
            toggle-class="header-item"
            menu-class="dropdown-menu-end"
          >
            <template v-slot:button-content>
              <img
                class="rounded-circle header-profile-user"
                :src="
                  Avatar
                    ? Avatar
                    : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAeCAMAAACR41cYAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAJ/UExURUdwTCEgIB8fHyAfHyAfHyAfHyAfHx8eHiAfHx8eHiAfHyAfHyAfHx8eHiAfH5jU5h8eHiAfHyAfHyAfHx8eHh8eHiAfHyAfIAQBAxgWFiEhISEgIAwCACAgIB0bGi40NhkVFCAfH5za8FBncENVXKTm95vZ8Jza8J7c8R0bGhMTEx0cHCAfHyEgH73//yEgIJ7c8QAAAIfF6TM7PwwJCh4cHHm45SAfHyAfH5za8CAfH5za8Jza8Jza8Jza8CAfH5za8G6VokRVWxIKCJza8JvY7pza8DtITTlFSZ3b8AMHCgAABJza8ElBPDA4PFVLRK3z/zEvLRcXGEVBPTA5PJza8AADB5vZ74XD6QIAAIrJ67T+/4HA6BAIByAfH4zK7IrI6zE4O7D5/yAfHwEAACIgIJza8BUWGAACBhoaGvXLsQ0PEZ/g957c8RATFf/oy1p4hfzRticqLIC+6Jrm///jxiMiIvDEq//Xu/bHq//fxG5eVRgXF////P/z0P/22lNHQv/gv//877H5/xcTEhUOC76cicyolCcjIf/avdivlpvY7mZaUQMHC1lNRfrNsPTJr//o0v/cwf3WuHtnXIshF4VuYvTEqfrcyM+oqOrW1PTm4v716zM7PqHf8v/t1SkpJsD//1RueGebxaPn/IXK/TVIV3OapbmXheK0mNuymv/GrdWZhu/Tx+u7pI54adymkf/658+dlMifn+S1mafq+7uhizYvLeLCufLs7/rk1mNVTf/NrtOskqeHd8aXlXFgVv/kwZU1LNW1neK9tJAuJsCMirJwa+nKv9zFx2CRtVuKronG6naszSUnKUZaZG+TmUFPU3agr3GkxIu8xSfH+3sAAABzdFJOUwD97RwqJTMat/4VL6DlCwmSOh2qV77yhGEIms8njIj9+xEk6wESA6CMcwRtUGQlwnjIs9iu9u3fsS5e3hvwhB66hguP9eJfotdT9nPf4o7mPNW62Kc/5MnTMeRzzcTG3/LkYv////////////////////54WQMpAAACTklEQVQYGXXABVMiYRgA4BdYdhkExa5TR8Xuvu7u7v5g2V06XFGxO7C72+vu7s74Qaczd87sIg/85yeUJMMCsUK+FFzIEEISvwSZxF8iSwpEczyBT4L4xMAXhniE4CIQ8QRgwCMWID458PgipEYag0ZD07TGYHCgOcuBI1GIWA3lqEcOrVbrUNdXUzSLfIHDB7EG7fXGi411tRdq6y7dedrl1KjTgGMNop3PSm+WGO35+fkNHSUlpT0U8geO4ABneUX7w9tXWxmGKXzU/7HyyX2tBLhCVT0vh/q7b7W3MW1Fb169H6p4TIXAP1IRQfiIMV/qRUXl8+4HHUwnY//w9l1lZ7kzHBP7EIRICpg3juMemLd2zGwcHOjrLbjB9PYNDI72sgYc88Bx3BsDQiSN9FQCpFDFxrKyVvO1KwXmwtGy0i4qBUDpGSkVEbDA73D5vYIGo/2y3Vhkfl28PQl4NoQABAdl79vV0lzc3LLnwP4dBPB4rbNkwbwM1byMRHAVk7qe3gIAyWpWIBCwKAgWFTS8dfdBQY5cIMsRsv6wuARLhIU+rUBhKCQgFNwIPrYkTR6uVqjD80LBvWxhIFKgsLxT4IYy9XyWJbo6ujo64tyJvbGwiM1H9OM/kalmosb0bXhct2m1F/DExpG6KZPqxy/Vd9XsrGriro5cEQVcUSSp05s+T0XU/HGM6T6Z9DqSjAcur7Vkk77KNjnzu+rrzKStSt9ErloGfOk7yRGr1Tb9ZdpmtY6QG+NWgivlofTMk2dyz+YeP5oZvy0GFvwFlSbPVswTomsAAAAASUVORK5CYII='
                "
                :alt="UserNameSurName"
              />
              <span class="d-none d-xl-inline-block ms-1">{{
                UserNameSurName
              }}</span>
              <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
            </template>

            <b-dropdown-item>
              <router-link tag="span" to="/profiledit">
                <i class="mdi mdi-account font-size-16 align-middle me-1"></i>
                {{ $t("navbar.kullanici.profil") }} {{ GetUserTur }}
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link tag="span" to="/mzneposta">
                <i class="mdi mdi-account-multiple font-size-16 align-middle me-1"></i>
                {{ $t("navbar.kullanici.mzneposta") }}
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link tag="span" to="/logout">
                <i
                  class="
                    bx bx-power-off
                    font-size-16
                    align-middle
                    me-1
                    text-danger
                  "
                ></i>
                {{ $t("navbar.kullanici.cikisyap") }}
              </router-link>
            </b-dropdown-item>
          </b-dropdown>
        </li>
        <template v-for="(Data, index) in MenuData">
          <li class="list-item" :key="index" v-if="!Data.Auth">
            <a :href="Data.Link + '/' + lan" class="link">{{ Data.Title }} </a>
            <MobilAltMenu :MenuData="Data.Children" v-if="Data.Children" />
          </li>
          <li
            class="list-item"
            :key="index"
            v-if="Data.Auth && AuthKontrol && UserTur == 'Mezun'"
          >
            <a :href="Data.Link" class="link">{{ Data.Title }} </a>
            <MobilAltMenu :MenuData="Data.Children" v-if="Data.Children" />
          </li>
          <li
            class="list-item"
            :key="index"
            v-if="
              Data.Auth &&
              AuthKontrol &&
              UserTur == 'Firma' 
              && Data.Title !== 'Harita'
            "
          >
            <a :href="Data.Link" class="link">{{ Data.Title }} </a>
            <MobilAltMenu :MenuData="Data.Children" v-if="Data.Children" />
          </li>
        </template>
      </ul>
    </div>
  </header>
</template>
<style>
.menu.mobile-hidden .menu-list {
  display: flex;
  gap: 12px;
  align-items: center;
}

.menu.mobile-hidden .menu-list .list-item > .link {
  background: rgba(0, 117, 143, 0.8) !important;
  padding: 8px 12px !important;
  border-radius: 4px !important;
  color: #fff !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  line-height: 1.4 !important;
  white-space: nowrap !important;
  display: inline-block !important;
  transition: all 0.2s ease !important;
}

.menu.mobile-hidden .menu-list .list-item > .link:hover {
  background: rgba(0, 117, 143, 0.95) !important;
  color: #fff !important;
  padding-bottom: 8px !important; /* Overrides the main.css jumping hover padding-bottom: 12px */
  text-decoration: none !important;
}
</style>
